// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteAccount_container__zb9Zs {
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(51, 215, 69) 39%, rgb(0, 84, 255) 100%);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.DeleteAccount_container__zb9Zs .DeleteAccount_cardContainer__NrvSY {
  width: 500px;
  padding: 20px;
  background-color: white;
  box-sizing: border-box;
}
.DeleteAccount_container__zb9Zs .DeleteAccount_cardContainer__NrvSY .DeleteAccount_deleteTitle__reSM3 {
  text-align: center;
  margin-bottom: 20px;
}
.DeleteAccount_container__zb9Zs .DeleteAccount_cardContainer__NrvSY .DeleteAccount_deleteDescription__sUqu9 {
  text-align: center;
  margin-bottom: 20px;
}
.DeleteAccount_container__zb9Zs .DeleteAccount_cardContainer__NrvSY .DeleteAccount_formContainer__WagNa {
  width: 100%;
}
.DeleteAccount_container__zb9Zs .DeleteAccount_cardContainer__NrvSY .DeleteAccount_inputField__xZcwc {
  width: 100%;
  margin-bottom: 10px;
}
.DeleteAccount_container__zb9Zs .DeleteAccount_cardContainer__NrvSY .DeleteAccount_deleteButton__bFT7x {
  width: 100%;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/delete-account/DeleteAccount.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,qGAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AACJ;AACI;EACE,kBAAA;EACA,mBAAA;AACN;AAEI;EACE,kBAAA;EACA,mBAAA;AAAN;AAGI;EACE,WAAA;AADN;AAII;EACE,WAAA;EACA,mBAAA;AAFN;AAKI;EACE,WAAA;EACA,gBAAA;AAHN","sourcesContent":[".container {\n  background: rgb(255, 255, 255);\n  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(51, 215, 69, 1) 39%, rgba(0, 84, 255, 1) 100%);\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .cardContainer {\n    width: 500px; // Set a specific width\n    padding: 20px;\n    background-color: white;\n    box-sizing: border-box; // Include padding in the width calculation\n\n    .deleteTitle {\n      text-align: center;\n      margin-bottom: 20px;\n    }\n\n    .deleteDescription {\n      text-align: center;\n      margin-bottom: 20px;\n    }\n\n    .formContainer {\n      width: 100%;\n    }\n\n    .inputField {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n\n    .deleteButton {\n      width: 100%;\n      margin-top: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeleteAccount_container__zb9Zs`,
	"cardContainer": `DeleteAccount_cardContainer__NrvSY`,
	"deleteTitle": `DeleteAccount_deleteTitle__reSM3`,
	"deleteDescription": `DeleteAccount_deleteDescription__sUqu9`,
	"formContainer": `DeleteAccount_formContainer__WagNa`,
	"inputField": `DeleteAccount_inputField__xZcwc`,
	"deleteButton": `DeleteAccount_deleteButton__bFT7x`
};
export default ___CSS_LOADER_EXPORT___;
